import axios, { AxiosRequestConfig } from 'axios';
import { useBrandConfig } from '@/utils/useBrandConfig';
import { AuthStore } from '@/store/auth/auth.store';
import { SignInApiResponse } from '@/store/auth/auth.service';


const createTPAxios = () => {
  const brandConfig = useBrandConfig();
  const authStore = AuthStore();

  const config: AxiosRequestConfig = {
    baseURL: `${import.meta.env.VITE_TP_API_URL}/api`,
    headers: {
      'through-brand-name': brandConfig.accessKey,
    },
  };

  const TPAxios = axios.create(config);

  TPAxios.interceptors.request.use(async config => {
    const accessToken = await authStore.getAuthAccessToken()

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
  });

  TPAxios.interceptors.response.use(
    response => response,
    async error => {
      const originalRequest = error.config;
      const refreshToken = await authStore.getAuthRefreshToken();

      if (error.response?.status === 401 &&
        refreshToken &&
        !originalRequest._retry &&
        !originalRequest.url.includes('/auth/refresh')) {

        try {
          const response = await TPAxios.post<SignInApiResponse>('/auth/refresh', { refreshToken });

          if (response.status === 401) {
            authStore.signOut();
            return Promise.reject(error);
          }

          if (response.status === 200) {
            const { account: data, token: accessToken, refreshToken } = response.data.data;

            await authStore.signIn({ data, accessToken, refreshToken });
          }

          try {
            return await TPAxios(error.config);
          } catch (retryError) {
            authStore.signOut();
            return Promise.reject(retryError);
          }
        } catch (refreshError) {
          authStore.signOut();
          return Promise.reject(refreshError);
        }
      }
      return Promise.reject(error);
    }
  );

  return TPAxios;
};

const createAxios = () => {

  const config: AxiosRequestConfig = {
    baseURL: `${import.meta.env.VITE_TP_API_URL}/api`,
  };

  const TPAxios = axios.create(config);

  TPAxios.interceptors.request.use(config => {
    return config;
  });

  TPAxios.interceptors.response.use(undefined, error => {
    return Promise.reject(error);
  });

  return TPAxios;
};



export { createTPAxios, createAxios };
